import React from "react";
import {CallbackErrorModalFL, CallbackFinishedModalFL} from "./ModalForm";
import "../../Business/Form/FormAtelier.scss";

type FormConfirmProps = {
    onFinished: CallbackFinishedModalFL;
    onError: CallbackErrorModalFL;
    dataConfirm: any | undefined;
};

const FormConfirm: React.FunctionComponent<FormConfirmProps> = ({dataConfirm, onFinished, onError}) => {
    return (
        <form className="fcaForm" onSubmit={(e) => e.preventDefault()}>
            {dataConfirm.msg && (
                <div className="fcaSection">
                    <p style={{fontSize: "14px", color: "var(--text-secondary)", margin: 0}}>
                        {dataConfirm.msg}
                    </p>
                </div>
            )}

            <div className="fcaActions">
                <button type="button" className="fcaBtn fcaBtnSecondary" onClick={() => {
                    if (dataConfirm.onCanceled) {
                        dataConfirm.onCanceled();
                    }
                    onFinished();
                }}>
                    <span className="material-symbols-outlined">close</span>
                    Annuler
                </button>
                <button type="button" className="fcaBtn fcaBtnPrimary" onClick={() => {
                    if (dataConfirm.onConfirm) {
                        dataConfirm.onConfirm();
                        onFinished();
                    } else {
                        onError("Pas d'évènement de confirmation");
                    }
                }}>
                    <span className="material-symbols-outlined">check</span>
                    Confirmer
                </button>
            </div>
        </form>
    );
}

export default FormConfirm;